import React from "react";
import AppHealthTab from "../components/AppHealthTab";

export default function HealthPage() {
  return (
    <div className="min-h-screen bg-gray-950">
      <AppHealthTab app="opsive" />
    </div>
  );
}
